import { Menu } from 'ui/src/dtos/Menu';
import menus from '../data/menus.json';

export const getMenus = (): Menu[] => {
	return menus;
};
